import Button from 'components/Form/Button';
import BasicTable from 'components/Form/Table';
import TableWrapper from 'components/TableWrapper';
import ContainerAuthenticated from 'containers/Authenticated';
import { CoreContext } from 'context/CoreContext';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Read } from 'services/financing-desk-controls';
import { TableInfo, Touch } from 'ui/styled';
import { exposeStrapiError, marcadorDiferente, parseStrapiImage } from 'utils';
import { normalizeName } from 'utils/validators';

export default function Biblioteca() {
  const history = useHistory();
  const navigate = useCallback((to) => history.push(`/${to}`), [history]);
  const [loading, setLoading] = useState(false);
  const [registers, setRegisters] = useState([]);
  const { user, filterExpression, setModal } = useContext(CoreContext);

  const columns = useMemo(
    () =>
      [
        {
          title: 'Id',
          ref: 'proposta',
          sortable: true,
          renderCell: ({ row }) => {
            // Condição: Se o campo 'curadoria_analise' for 'Analisado'
            const isAnalisadoCuradoria = row?.curadoria_analise === 'Analisado';
            const isAnalisadoBot = row?.curadoria_analise_bot === 'Analisado';
            const id = row?.proposta;
            if (isAnalisadoCuradoria || isAnalisadoBot) {
              return marcadorDiferente(id, '!');
            }
            return id;
          },
        },
        { title: 'Cliente', ref: 'cliente', sortable: true },
        {
          title: 'Espelho da proposta',
          ref: 'espelho',
          renderCell: ({ row }) => (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                onClick={() => navigate(`proposals/financing/${row?.proposta}`)}
                color="blue"
                nospace
                mbutton
                small
              >
                Visualizar
              </Button>
            </div>
          ),
        },
        {
          title: 'Fatura de Energia',
          ref: 'fatura',
          renderCell: ({ row }) => {
            const rawValue = row?.fatura;
            const parsedUrl = parseStrapiImage(rawValue);
            const hasFile =
              !!rawValue && !!parsedUrl && parsedUrl.trim() !== '';
            const label = hasFile ? 'Arquivo' : '';
            const color = hasFile ? 'blue' : '';
            return (
              <Touch
                onClick={
                  hasFile ? () => window.open(parsedUrl, 'new') : undefined
                }
                style={{
                  color,
                  cursor: hasFile ? 'pointer' : 'default',
                  pointerEvents: hasFile ? 'auto' : 'none',
                }}
              >
                <TableInfo style={{ color }}>{label}</TableInfo>
              </Touch>
            );
          },
        },
        {
          title: 'Doc. Ident.',
          ref: '',
          renderCell: ({ row }) => {
            const rawValue = row?.docind;
            const parsedUrl = parseStrapiImage(rawValue);
            const hasFile =
              !!rawValue && !!parsedUrl && parsedUrl.trim() !== '';
            const label = hasFile ? 'Arquivo' : '';
            const color = hasFile ? 'blue' : '';
            return (
              <Touch
                onClick={
                  hasFile ? () => window.open(parsedUrl, 'new') : undefined
                }
                style={{
                  color,
                  cursor: hasFile ? 'pointer' : 'default',
                  pointerEvents: hasFile ? 'auto' : 'none',
                }}
              >
                <TableInfo style={{ color }}>{label}</TableInfo>
              </Touch>
            );
          },
        },
        {
          title: 'Doc. Expedição',
          ref: '',
          renderCell: ({ row }) => {
            const rawValue = row?.documentoExpedicao;
            const parsedUrl = parseStrapiImage(rawValue);
            const hasFile =
              !!rawValue && !!parsedUrl && parsedUrl.trim() !== '';
            const label = hasFile ? 'Arquivo' : '';
            const color = hasFile ? 'blue' : '';
            return (
              <Touch
                onClick={
                  hasFile ? () => window.open(parsedUrl, 'new') : undefined
                }
                style={{
                  color,
                  cursor: hasFile ? 'pointer' : 'default',
                  pointerEvents: hasFile ? 'auto' : 'none',
                }}
              >
                <TableInfo style={{ color }}>{label}</TableInfo>
              </Touch>
            );
          },
        },
        {
          title: 'Ciencia de Compra',
          ref: 'ciencia',
          renderCell: ({ row }) => {
            const rawValue = row?.ciencia;
            const parsedUrl = parseStrapiImage(rawValue);
            const hasFile =
              !!rawValue && !!parsedUrl && parsedUrl.trim() !== '';
            const label = hasFile ? 'Arquivo' : '';
            const color = hasFile ? 'blue' : '';
            return (
              <Touch
                onClick={
                  hasFile ? () => window.open(parsedUrl, 'new') : undefined
                }
                style={{
                  color,
                  cursor: hasFile ? 'pointer' : 'default',
                  pointerEvents: hasFile ? 'auto' : 'none',
                }}
              >
                <TableInfo style={{ color }}>{label}</TableInfo>
              </Touch>
            );
          },
        },
        {
          title: 'Aut. Faturamento',
          ref: 'autFaturamento',
          renderCell: ({ row }) => {
            //console.log("row", row);
            const rawValue = row?.autFaturamento;
            const parsedUrl = parseStrapiImage(rawValue);
            const hasFile =
              !!rawValue && !!parsedUrl && parsedUrl.trim() !== '';
            const label = hasFile ? 'Arquivo' : '';
            const color = hasFile ? 'blue' : '';
            return (
              <Touch
                onClick={
                  hasFile ? () => window.open(parsedUrl, 'new') : undefined
                }
                style={{
                  color,
                  cursor: hasFile ? 'pointer' : 'default',
                  pointerEvents: hasFile ? 'auto' : 'none',
                }}
              >
                <TableInfo style={{ color }}>{label}</TableInfo>
              </Touch>
            );
          },
        },
        {
          title: 'Recomen. Crédito',
          ref: '',
          renderCell: ({ row }) => {
            const rawValue = row?.credito;
            const parsedUrl = parseStrapiImage(rawValue);
            const hasFile =
              !!rawValue && !!parsedUrl && parsedUrl.trim() !== '';
            const label = hasFile ? 'Arquivo' : '';
            const color = hasFile ? 'blue' : '';
            return (
              <Touch
                onClick={
                  hasFile ? () => window.open(parsedUrl, 'new') : undefined
                }
                style={{
                  color,
                  cursor: hasFile ? 'pointer' : 'default',
                  pointerEvents: hasFile ? 'auto' : 'none',
                }}
              >
                <TableInfo style={{ color }}>{label}</TableInfo>
              </Touch>
            );
          },
        },
        {
          title: 'CCB',
          ref: '',
          renderCell: ({ row }) => {
            const rawValue = row?.contratoFinan;
            const parsedUrl = parseStrapiImage(rawValue);
            const hasFile =
              !!rawValue && !!parsedUrl && parsedUrl.trim() !== '';
            const label = hasFile ? 'Arquivo' : '';
            const color = hasFile ? 'blue' : '';
            return (
              <Touch
                onClick={
                  hasFile ? () => window.open(parsedUrl, 'new') : undefined
                }
                style={{
                  color,
                  cursor: hasFile ? 'pointer' : 'default',
                  pointerEvents: hasFile ? 'auto' : 'none',
                }}
              >
                <TableInfo style={{ color }}>{label}</TableInfo>
              </Touch>
            );
          },
        },
        {
          title: 'NF Produto',
          ref: '',
          renderCell: ({ row }) => {
            const rawValue = row?.nfVenda;
            const parsedUrl = parseStrapiImage(rawValue);
            const hasFile =
              !!rawValue && !!parsedUrl && parsedUrl.trim() !== '';
            const label = hasFile ? 'Arquivo' : '';
            const color = hasFile ? 'blue' : '';
            return (
              <Touch
                onClick={
                  hasFile ? () => window.open(parsedUrl, 'new') : undefined
                }
                style={{
                  color,
                  cursor: hasFile ? 'pointer' : 'default',
                  pointerEvents: hasFile ? 'auto' : 'none',
                }}
              >
                <TableInfo style={{ color }}>{label}</TableInfo>
              </Touch>
            );
          },
        },
        {
          title: 'NF Serviço',
          ref: '',
          renderCell: ({ row }) => {
            const rawValue = row?.nfCompra;
            const parsedUrl = parseStrapiImage(rawValue);
            const hasFile =
              !!rawValue && !!parsedUrl && parsedUrl.trim() !== '';
            const label = hasFile ? 'Arquivo' : '';
            const color = hasFile ? 'blue' : '';
            return (
              <Touch
                onClick={
                  hasFile ? () => window.open(parsedUrl, 'new') : undefined
                }
                style={{
                  color,
                  cursor: hasFile ? 'pointer' : 'default',
                  pointerEvents: hasFile ? 'auto' : 'none',
                }}
              >
                <TableInfo style={{ color }}>{label}</TableInfo>
              </Touch>
            );
          },
        },
        {
          title: 'Comp. Pagamento',
          ref: '',
          renderCell: ({ row }) => {
            const rawValue = row?.compPagamento;
            const parsedUrl = parseStrapiImage(rawValue);
            const hasFile =
              !!rawValue && !!parsedUrl && parsedUrl.trim() !== '';
            const label = hasFile ? 'Arquivo' : '';
            const color = hasFile ? 'blue' : '';
            return (
              <Touch
                onClick={
                  hasFile ? () => window.open(parsedUrl, 'new') : undefined
                }
                style={{
                  color,
                  cursor: hasFile ? 'pointer' : 'default',
                  pointerEvents: hasFile ? 'auto' : 'none',
                }}
              >
                <TableInfo style={{ color }}>{label}</TableInfo>
              </Touch>
            );
          },
        },
        {
          title: 'Parecer de Acesso',
          ref: '',
          renderCell: ({ row }) => {
            const rawValue = row?.parecerAcesso;
            const parsedUrl = parseStrapiImage(rawValue);
            const hasFile =
              !!rawValue && !!parsedUrl && parsedUrl.trim() !== '';
            const label = hasFile ? 'Arquivo' : '';
            const color = hasFile ? 'blue' : '';
            return (
              <Touch
                onClick={
                  hasFile ? () => window.open(parsedUrl, 'new') : undefined
                }
                style={{
                  color,
                  cursor: hasFile ? 'pointer' : 'default',
                  pointerEvents: hasFile ? 'auto' : 'none',
                }}
              >
                <TableInfo style={{ color }}>{label}</TableInfo>
              </Touch>
            );
          },
        },
        {
          title: 'Protoc. de Vistoria',
          ref: '',
          renderCell: ({ row }) => {
            const rawValue = row?.protocoloVistoria;
            const parsedUrl = parseStrapiImage(rawValue);
            const hasFile =
              !!rawValue && !!parsedUrl && parsedUrl.trim() !== '';
            const label = hasFile ? 'Arquivo' : '';
            const color = hasFile ? 'blue' : '';
            return (
              <Touch
                onClick={
                  hasFile ? () => window.open(parsedUrl, 'new') : undefined
                }
                style={{
                  color,
                  cursor: hasFile ? 'pointer' : 'default',
                  pointerEvents: hasFile ? 'auto' : 'none',
                }}
              >
                <TableInfo style={{ color }}>{label}</TableInfo>
              </Touch>
            );
          },
        },
        {
          title: '1° Fatur. de Energia c/ Crédito',
          ref: '',
          renderCell: ({ row }) => {
            const rawValue = row?.primeiraFatura;
            const parsedUrl = parseStrapiImage(rawValue);
            const hasFile =
              !!rawValue && !!parsedUrl && parsedUrl.trim() !== '';
            const label = hasFile ? 'Arquivo' : '';
            const color = hasFile ? 'blue' : '';
            return (
              <Touch
                onClick={
                  hasFile ? () => window.open(parsedUrl, 'new') : undefined
                }
                style={{
                  color,
                  cursor: hasFile ? 'pointer' : 'default',
                  pointerEvents: hasFile ? 'auto' : 'none',
                }}
              >
                <TableInfo style={{ color }}>{label}</TableInfo>
              </Touch>
            );
          },
        },
        {
          title: 'AUT. SERVIÇO ',
          ref: '',
          renderCell: ({ row }) => {
            const rawValue = row?.pdfautorizaservico;
            const parsedUrl = parseStrapiImage(rawValue);
            const hasFile =
              !!rawValue && !!parsedUrl && parsedUrl.trim() !== '';
            const label = hasFile ? 'Arquivo' : '';
            const color = hasFile ? 'blue' : '';
            return (
              <Touch
                onClick={
                  hasFile ? () => window.open(parsedUrl, 'new') : undefined
                }
                style={{
                  color,
                  cursor: hasFile ? 'pointer' : 'default',
                  pointerEvents: hasFile ? 'auto' : 'none',
                }}
              >
                <TableInfo style={{ color }}>{label}</TableInfo>
              </Touch>
            );
          },
        },
        {
          title: 'Observações',
          ref: '',
          renderCell: ({ row }) => (
            <Button
              onClick={() => {
                if (user?.administrador) {
                  setModal({
                    type: 'observacao',
                    dados: row,
                    reload: () => init(),
                  });
                }
              }}
              color="botao"
              nospace
              mbutton
              small
            >
              Historico
            </Button>
          ),
        },
      ].filter((f) => f),
    [navigate, user, setModal]
  );

  const rows = useMemo(() => {
    return registers?.map((item) => ({
      proposta: item?.proposta_financeira?.id,
      id: item?.id,
      original: item,
      cliente: normalizeName(
        item?.proposta_financeira?.informacoes_cliente?.nome_completo
      ),
      //usado no filtro:
      distributor: normalizeName(
        item?.proposta_financeira?.distribuidor?.trade_name
      ),
      integrator: normalizeName(
        item?.proposta_financeira?.integrador?.nome_fantasia
      ),
      city: normalizeName(
        item?.proposta_financeira?.endereco_instalacao?.cidade
      ),
      uf: item?.proposta_financeira?.endereco_instalacao?.uf,
      status: normalizeName(item?.proposta_financeira?.status),
      //fim do filtro.
      fatura: item?.proposta_financeira?.url_fatura,
      ciencia: item?.proposta_financeira?.pdf_ciencia_compra?.url,
      //caso nao tenha arquivo traz nulo.
      autFaturamento: item?.proposta_financeira?.pdf_recomenda_faturamento
        ? item?.proposta_financeira?.pdf_recomenda_faturamento.url
        : item?.proposta_financeira?.pdf_faturamento_unico
          ? item?.proposta_financeira?.pdf_faturamento_unico[0]?.url
          : null,
      credito: item?.proposta_financeira?.pdf_carta_credito?.url,
      contratoFinan: item?.proposta_financeira?.contrato_financiamento?.url,
      compPagamento: item?.proposta_financeira?.comprovante_pagamento?.url,
      nfVenda: item?.proposta_financeira?.nf_venda?.url,
      nfCompra: item?.proposta_financeira?.nf_compra?.url,
      parecerAcesso: item?.parecer_acesso_midia?.url,
      protocoloVistoria: item?.protocolo_acesso_midia?.url,
      primeiraFatura: item?.primeira_fatura_midia?.url,
      //aqui tem espelho
      espelho: item?.proposta_financeira?.espelho_pdf?.[0]?.url,
      documentoExpedicao: item?.documento_expedicao?.url,
      pdfautorizaservico: item?.proposta_financeira?.pdf_autoriza_servico?.url,
      curadoria_analise: item?.proposta_financeira?.curadoria_analise, // Assumindo que este campo está no backend
      //envia esse campo apenas para o modal da oberservações para identificar que esta na biblioteca
      biblioteca: true,
      // cnpj_integrador: item?.proposta_financeira?.integrador?.cnpj,
      // cnpj_integrador_clean:
      //   item?.proposta_financeira?.integrador?.cnpj.replace(/\D/g, ''),
      // cpf_cnpj:
      //   item?.proposta_financeira?.informacoes_cliente?.cpf ||
      //   item?.proposta_financeira?.informacoes_cliente?.cnpj,
      // cpf_cnpj_clean: item?.proposta_financeira?.informacoes_cliente?.cpf
      //   ? item?.proposta_financeira?.informacoes_cliente?.cpf.replace(/\D/g, '')
      //   : item?.proposta_financeira?.informacoes_cliente?.cnpj.replace(
      //       /\D/g,
      //       ''
      //     ),
      cpf_cnpj: item?.cpf_cliente || '-',
      cpf_cnpj_clean: item?.cpf_cliente ?? item?.cpf_cliente.replace(/\D/g, ''),
    }));
  }, [registers]);
  const init = async () => {
    setLoading(true);
    const result = await Read(
      '?filters[$or][0][status][$eq]=Expedição' +
        '&filters[$or][1][status][$eq]=Entrega e Parecer de acesso' +
        '&filters[$or][2][status][$eq]=Instalação e Protocolo de conexão' +
        '&filters[$or][3][status][$eq]=Conexão e 1ª Parcela' +
        '&filters[$or][4][status][$eq]=Primeira Fatura' +
        '&filters[$or][5][status][$eq]=Protocolo Evon' +
        '&filters[$or][6][status][$eq]=Ciência de compra' +
        '&filters[proposta_financeira][status][$notIn][0]=declinada' +
        '&filters[proposta_financeira][status][$notIn][1]=negado'
    );
    setLoading(false);
    if (result && !exposeStrapiError(result)) {
      const nresult = result.results
        ?.map((m) => ({ ...m }))
        ?.sort((a, b) => {
          // Pega a data de contato para a proposta 'a'
          //const dateA = moment(a.data_entrada_conexao || a.data_enviar_conexao);
          // Pega a data de contato para a proposta 'b'
          //const dateB = moment(b.data_entrada_conexao || b.data_enviar_conexao);
          // Retorna a diferença
          // Se dateA for mais antiga, o resultado é negativo e 'a' é colocado antes de 'b'.
          //Giovani 01/12/2025 - Reordenado Ordenação decrescente por ID
          return b.id - a.id;
        });
      setRegisters(nresult);
    }
  };

  useEffect(() => init(), []);

  return (
    <>
      <ContainerAuthenticated>
        <TableWrapper title={'Arquivos das propostas'} search>
          <BasicTable
            loading={loading}
            columns={columns}
            rows={rows?.filter(filterExpression)}
            pagination
            fixedColumns={2}
          />
        </TableWrapper>
      </ContainerAuthenticated>
    </>
  );
}
